var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipLoader10M3Ld10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "144 130 553 335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Skip_Loader_10m3_LD10_svg__st0{fill:currentColor}.Skip_Loader_10m3_LD10_svg__st1{opacity:.4}.Skip_Loader_10m3_LD10_svg__st1,.Skip_Loader_10m3_LD10_svg__st2{fill:#1d1d1b;enable-background:new}.Skip_Loader_10m3_LD10_svg__st8{enable-background:new}.Skip_Loader_10m3_LD10_svg__st2,.Skip_Loader_10m3_LD10_svg__st8{opacity:.1}.Skip_Loader_10m3_LD10_svg__st8{fill:#fff}.Skip_Loader_10m3_LD10_svg__st11,.Skip_Loader_10m3_LD10_svg__st12{opacity:.2;fill:#fff}.Skip_Loader_10m3_LD10_svg__st13{fill:#fff}.Skip_Loader_10m3_LD10_svg__st12,.Skip_Loader_10m3_LD10_svg__st13{enable-background:new}.Skip_Loader_10m3_LD10_svg__st13{opacity:5.000000e-02}.Skip_Loader_10m3_LD10_svg__st14,.Skip_Loader_10m3_LD10_svg__st15{opacity:.8;fill:#030405;enable-background:new}.Skip_Loader_10m3_LD10_svg__st15{opacity:.4}.Skip_Loader_10m3_LD10_svg__st16{opacity:.4}.Skip_Loader_10m3_LD10_svg__st17{fill:#030405}.Skip_Loader_10m3_LD10_svg__st18,.Skip_Loader_10m3_LD10_svg__st19{opacity:.2;fill:#030405}.Skip_Loader_10m3_LD10_svg__st20{opacity:.2}.Skip_Loader_10m3_LD10_svg__st19,.Skip_Loader_10m3_LD10_svg__st20{enable-background:new}.Skip_Loader_10m3_LD10_svg__st20{fill:#161615}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 331 284"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 331,
    height: 284,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Container_3_00000081649747011233392810000011983594147285550225_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Bakgrund_\\xC4ndra_F\\xE4rg_00000016759435034719997240000016302682282556166815_",
    d: "m144.7 162.6 10.2 1.9.5 80.2 11.4 35.5-9 1.7-5.9 4.3 2.7 8.5 9-1.8 8 2.1 32.8 101 213.2 69.1 94.5-32.7 1.8-3.4 12.4-4.2 4.4 1.3 81.2-27.9 43.7-77 17-5 5-8.7-7.1-6.3-3.6-.6 6.5-11.4 17.3-4.6 6.6-11.7-7.7-6-33.4-102.4-307.5-34.4-204 22v10.5z",
    className: "Skip_Loader_10m3_LD10_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_10_x25__00000132052095229702307650000002382557704009421462_",
    d: "M453.4 198.1 470 195l39.6 117.4 165.2-41.6-33.9-102.9 15.3-3.3L689.6 267l7.7 6L501 324.5l-9.6-7.6-38-118.8z",
    className: "Skip_Loader_10m3_LD10_svg__st13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_80_x25__00000126318520898977085380000004992890827146856856_",
    d: "m517.9 421.1 6.9-13.5 18.2-5.9-12.4 24.4-4.4-1.3 4.6-1.5s1.9-.9.9-3.9c-.9-2.9-2.8-1.9-2.8-1.9l-11 3.6z",
    className: "Skip_Loader_10m3_LD10_svg__st14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_40_x25__00000147195858546700219790000009892478019284745890_",
    d: "m500.9 324.4-7.2 13.3 196.9-53 6.6-11.7-196.3 51.4z",
    className: "Skip_Loader_10m3_LD10_svg__st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Highlight_10_x25__00000140702794553632102950000013233383470563236491_",
    d: "m477.3 365.9-10.5-7.5-91.5-22.7-18.9-30.6V196l89.7 13.9 39.8 120.8 7.9 6.9 7.2-13.3-9.6-7.6-37.9-118.8L144.7 152v10.5l10.2 1.9 72.1 11.5.2 99.1-15.2 20-54.4-13-5.9 4.3 2.7 8.5 4.1-2.9L461 368.2l8.3 7.6 8-9.9m-243.1-65.1V177.1l113.6 17.6.3 117.8c-.6-.7-1.5-1-2.4-.9-1.7.4-2.6 2.8-2 5.5s2.4 4.5 4.2 4.1c.1 0 .2-.1.3-.1v8l-114-28.3z",
    className: "Skip_Loader_10m3_LD10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Skip_Loader_10m3_LD10_Logo",
    transform: "translate(144.8,130.3)",
    d: "m47.962 79.479h193.22v113.28h-193.22z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_40_x25__00000178918128510665032930000011042842450736635525_",
    transform: "translate(44.963 85.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Group_4925",
    className: "Skip_Loader_10m3_LD10_svg__st16",
    transform: "translate(68.447 16.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25279",
    d: "M240.1 212.8c0-.8-.6-1.5-1.3-1.7h-.6c-.5-1.3-1.6-2.2-3-2.5 0 0-2.3.4-3 .6-.1 0-.3.1-.3.1l.3-.1c1.6-.4 3.6 1.5 4.2 4.1.6 1.9.1 4-1.4 5.3l2-.4s1.8-.6 2.1-3.6c1-.2 1-1 1-1.8z",
    className: "Skip_Loader_10m3_LD10_svg__st17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Group_4926",
    className: "Skip_Loader_10m3_LD10_svg__st16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25280",
    d: "M187.5 200.3c0-.8-.6-1.5-1.3-1.7h-.6c-.5-1.3-1.6-2.2-3-2.5l-2.9.7c1.7-.3 3.5 1.5 4.1 4.1.6 1.9.1 4-1.4 5.3l2-.4s1.8-.6 2.1-3.6c1-.3 1-1.1 1-1.9z",
    className: "Skip_Loader_10m3_LD10_svg__st17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25281",
    d: "M179.2 197c.1 0 .2 0 .3-.1l-.3.1z",
    className: "Skip_Loader_10m3_LD10_svg__st17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25282",
    d: "M179.6 196.9c.1 0 0 0 0 0z",
    className: "Skip_Loader_10m3_LD10_svg__st17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_20_x25__00000131341415124689366120000011890236480247102636_",
    transform: "translate(154.201 89.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25283",
    d: "m323.1 276-7.9 9.8-8.3-7.6-43.7 97.1 94.5-32.7 12.8-24.9 18.2-5.9-12.4 24.4 81.2-27.9 43.7-77 17-5 5-8.7L323.1 276z",
    className: "Skip_Loader_10m3_LD10_svg__st18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25284",
    d: "m318.8 266.6-5-1.4 15.7-30.7 2.1 6.3 7.9 6.9 179.6-48.4-7.7 13.5-192.6 53.8z",
    className: "Skip_Loader_10m3_LD10_svg__st18"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_20_x25__00000154409722656702513490000006657146262559576747_",
    d: "m477.3 365.9-7.9 9.8 203-59.5 5-8.7-200.1 58.4z",
    className: "Skip_Loader_10m3_LD10_svg__st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Highlight_20_x25__00000002375152265431211300000003360124060024634497_",
    d: "m466.8 358.5 10.5 7.5 200.1-58.4-7.1-6.3-3.6-.6-1.2 2.1-198.7 55.7z",
    className: "Skip_Loader_10m3_LD10_svg__st12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_20_x25__00000178914861309336999600000017262316743223773089_",
    transform: "translate(21.907 16.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25366_00000041291357404460984580000006974346694600323971_",
    d: "m212.2 284.2 5.6-1.7.5-121.1-6.1-.9v123.7z",
    className: "Skip_Loader_10m3_LD10_svg__st20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25367_00000152259928517119341730000014251048504162762894_",
    d: "m340.7 286.2-.1-105.8-6.2-1.1v109.1l18.9 30.6 6.5-1.8-19.1-31z",
    className: "Skip_Loader_10m3_LD10_svg__st20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Highlight_20_x25__00000036932257221643740420000004810376342509489847_",
    transform: "translate(7.4 84.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25355_00000078734447889967351890000011271882045159520187_",
    d: "m226.8 215.8 5.6-1.7 108.2 26.4.1 3.5-113.9-28.2z",
    className: "Skip_Loader_10m3_LD10_svg__st11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25356_00000180362684997035170140000012394971461802882472_",
    d: "m206.5 207.9-1.9 2.3-54.9-13.4 9-1.5.4 1.1 47.4 11.5z",
    className: "Skip_Loader_10m3_LD10_svg__st11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Path_25357_00000099649544818357346740000001650424455941605794_",
    d: "m367.9 250.8 6.5-1.8 91.2 22.6-6.3 1.9-91.4-22.7z",
    className: "Skip_Loader_10m3_LD10_svg__st11"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_60_x25__00000124159885509669446480000017265501014747458746_",
    d: "m177 151.9 172.7-18.1-.1 42.9L177 151.9z",
    className: "Skip_Loader_10m3_LD10_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Skugga_40_x25__00000062890097092674784480000014781664170427693221_",
    d: "m349.8 133.8-.1 42.9 120.9 18 39 117.6 165.2-41.6-33.9-102.9-291.1-34z",
    className: "Skip_Loader_10m3_LD10_svg__st2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_10m3_LD10_svg__Highlight_20_x25__00000016757536760395374390000001093369699139064746_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_10m3_LD10_svg__Highilight_20_x25__00000035524716948720699750000005410571430677733014_",
    d: "m337.8 131.2 10.8-1.1 307.5 34.4-15.3 3.3-291-34z",
    className: "Skip_Loader_10m3_LD10_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.6 194.7-17.2 3.4-308.7-46 193.1-20.9 12 2.6L177 151.9z",
    className: "Skip_Loader_10m3_LD10_svg__st12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipLoader10M3Ld10);
export default __webpack_public_path__ + "static/media/Skip_Loader_10m3_LD10.faccd88ac406df75bdec766a7afa3700.svg";
export { ForwardRef as ReactComponent };